module.exports = __webpack_public_path__ + "img/youzan.765d50c8.png";